<template>
  <b-modal
    title="Create Membership"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset">
    <template #modal-header-close>
      <h4>X</h4>
    </template>
      <b-row>
        <h2 v-show="groupOrgPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
        <pulse-loader :loading="groupOrgPending" color="#0F347B" size="50px"></pulse-loader>
      </b-row>


    <b-form>     
      <b-form-select 
      v-model="orgId"
      :options="organizationOptions(organizations)" 
      id='selectOrg' 
      size="lg">
      <option :value="null" disabled>-- Please select an organization --</option>
      </b-form-select>      
    </b-form>
    <b-alert
      dismissible
      fade
      :show="groupOrgFailure || _.isObject(groupOrgSuccess)"
      :variant="groupOrgFailure ? 'danger' : 'success'">
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button type="button" variant="primary" size="sm" class="float-right" @click="orgMemberHandler">
        <span class="button-text">Create</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CreateGroupOrgMembershipModal',
  props: {
    showModal: Boolean,
    existingMemOrg: Array,
    groupId: Number
  },
  data: function () {
    return {
      orgId: null
    }
  },
  computed: {
    ...mapGetters({
      organizations: 'getAllOrganizations',
      groupOrgPending: 'getCreateGroupOrgPending',
      groupOrgFailure: 'getCreateGroupOrgFailure',
      groupOrgSuccess: 'getCreateGroupOrgSuccess'
    })
  },
  watch: {
    groupOrgSuccess (newValue) {
      if (this.showModal) {
        if (this.showModal) {
          _.delay(this.reset, 1000)
        }
      }
    }
  },
  methods: {
    organizationOptions (organizations) {
      return _.sortBy(organizations, 'title').filter(f => {
        return !(this.existingMemOrg && this.existingMemOrg.indexOf(f.id) > -1)
      }).map((org) => {
        return { value: org.id, text: org.title }
      })
    },
    reset: function () {
      this.orgId = null
      this.$store.commit('resetCreateGroupOrg')
      this.$emit('update:showModal', false)
    },
    orgMemberHandler () {
      if (this.orgId && this.groupId) {
        this.$store.dispatch('createGroupOrg', {
          groupId: this.groupId,
          orgId: this.orgId
        })
      }
    },
    apiResponseMessage () {
      return (!this.groupOrgFailure) ? 'Success' : '<p>' + this.groupOrgFailure + '</p>'
    },
    getOrganizations () {
      this.$store.dispatch('getOrganizations', {})
    }
  },
  created: function () {
    this.getOrganizations()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Admin/CreateGroupOrgMembershipModal.vue